import { defineStore } from 'pinia';
import { ref } from 'vue';

export const TOGGLE_SIDE_NAV_HOTKEY = 'ctrl+.,cmd+.';

export const useCompanyNavigationStore = defineStore(
    'companyNavigation',
    () => {
        const showSideNav = ref(false);

        const toggleSideNav = () => {
            showSideNav.value = !showSideNav.value;
        };

        return {
            showSideNav,
            toggleSideNav,
        };
    },
    {
        persist: {
            storage: sessionStorage,
            debug: true,
        },
    },
);
